import CacheStorage from "../../service/storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import ApiUrls from "../../service/api/ApiUrls";
import ApiService from "../../service/api/ApiService";
import { BranchInfoModel } from "../../model/home/BranchInfoModel";
import { navigate } from "../../service/navigation/Navigation";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import ShowToast from "../../widget/common/ui/Toast";

const HomeProvider = new (class HomeProvider {
  navigate = (url: string) => {
    navigate(url);
  };

  updateFollowStatusAPI = async (barnchId: string): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}notice/follow_branch`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
      group_id: "0",
    };

    const response: any = await ApiService.postApi(url, body);
    console.log(response);
    if (response != null) {
      if (response["success"] === "1") {
        return response["result"]["follow_status"] === "1" ? true : false;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };

  getBranchDetail = async (
    bId: string = ""
  ): Promise<BranchInfoModel | null> => {
    ApiUrls.init();

    const barnchId: string = UtilityHelper.isNotEmpty(bId)
      ? bId
      : CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_branch_info`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const branchInfoModel: BranchInfoModel = response;
        return branchInfoModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default HomeProvider;
